import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import apiClient from "../client";

export const TRADINGVIEW_ACCOUNT_KEY = ["tradingview-account"] as const;

export interface TradingViewAccountDto {
  /** Null until the customer or staff give one. */
  username: string | null;
  /** The customer has had the TradingView add-on with it, so only staff can change it. */
  locked: boolean;
}

/** The account the TradingView add-on invites. */
export function useTradingViewAccount() {
  return useQuery<TradingViewAccountDto>({
    queryKey: TRADINGVIEW_ACCOUNT_KEY,
    queryFn: async () => {
      const res = await apiClient.get<TradingViewAccountDto>("/customers/me/tradingview-account");
      return res.data;
    },
  });
}

export function useSetTradingViewAccount() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (username: string) => {
      await apiClient.put("/customers/me/tradingview-account", { username });
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: TRADINGVIEW_ACCOUNT_KEY }),
  });
}
